<script lang="ts">
    export let balance: number;
</script>

<label>
    <p class="flex justify-between">
        Amount
        <span class="font-bold">${balance}</span>
    </p>
    <div
        class="flex justify-between overflow-hidden align-middle place-items-center w-full rounded-md border border-input bg-background text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
    >
        <input
            class="h-10 flex-1 px-3 py-2 border-none outline-none"
            placeholder="0.0"
            autocomplete="off"
            type="text"
            inputmode="decimal"
        />
        <span class="px-3 py-2">USD</span>
    </div>
</label>
<button
    aria-label="robinkit-wc"
    class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full"
    >Proceed</button
>
